import twire       from './twire';
import twireStripe from './twire.stripe';


'use strict';

export default function lynxPayment() {


	/**
	 * Cache
	 */
	var $htmlBody 	= $('html, body');
	var $main 		= $('main');
	var $form 		= $main.find('form[data-twire-form-name="book-now"]');


	/**
	 * Copy link
	 */
	$form.find('div.copy-billing-details a')
	     .on('click', function(e) {

		e.preventDefault();

		$form.find('input[name="billing-name"]').val($form.find('input[name="name"]').val());
		$form.find('input[name="billing-phone"]').val($form.find('input[name="phone"]').val());
		$form.find('input[name="billing-email"]').val($form.find('input[name="email"]').val());

	});


	/**
	 * Payment error
	 */
	var $paymentError = $main.find('div.payment-error');

	function paymentError(error) {
		
		$paymentError.text(error)
		             .addClass('active');
		
	}


	/**
	 * Stripe config
	 */
	var stripeElementsConfig = {

		fonts: [

			{ cssSrc: 'https://fonts.googleapis.com/css?family=Nunito:400,400i,700,700i' }

		],
		locale: 'auto'

	};

	var stripeStyle = {

		base: {

			iconColor: '#0F77AB',
			color: '#0F77AB',
			fontFamily: '"Nunito", sans-serif',
			fontSize: 'max(16px, 1.5vw)',
			'::placeholder': {

				color: '#91bfea'

			},

		},
		invalid: {

			color: '#E94410',
			iconColor: '#E94410'

		}

	};


	/**
	 * Set form field names
	 */
	twireStripe.cardBillingFormNames = {

		name: 	'billing-name',
		email:	'billing-email',
		phone: 	'billing-phone',
		address: {

			line1: 		'billing-address-line-1',
			line2: 		'billing-address-line-2',
			town: 		'billing-town',
			county: 	'billing-county',
			postcode: 	'billing-postcode',
			country:	'billing-country'

		}

	}

	$main.each(function() {

		// Set up Stripe
		twireStripe.init($form, $main.data('stripe-pk'), stripeElementsConfig, stripeStyle);

		// Handles success or failure via PHP redirect
		twireStripe.returnURL = window.location.origin + '/server/stripe-return-url-handler';
		
		twireStripe.onGeneralError = function($form, message) {
			
			paymentError(message);

			$form.removeClass('disabled');

		}

		twireStripe.onServerError = function($form, message) {

			alert(message);

			$form.remove();

		}

		twireStripe.onSuccess = function($form, paymentIntentID, mode) {
			
			$form.remove();

			// Create a URL object (relative or absolute)
		    const url = new URL($main.data('redirect-path'), window.location.origin);

		    // Use searchParams to add your data safely
		    url.searchParams.set('payment_intent', paymentIntentID);
		    url.searchParams.set('success', '1');
		    url.searchParams.set('mode', mode);

		    // Perform the redirect
		    // Use .replace() to prevent the "Back" button from re-triggering the payment logic
		    window.location.replace(url.href);

		}

		twireStripe.onPaymentStart = function($form) {

			$paymentError.removeClass('active')
			             .text('');

			$form.addClass('disabled');

		}

	});


	window.bookingFormSuccessful = function($form) {

		// Submit as normal form if requesting an invoice
		if ($form.find('input[name="payment-method"]').val() == 'invoice') {

			// Just submit, don't re-add handler here as you do with Stripe since
			// submitValidatedForm() will do that
			twire.forms.submitValidatedForm($form);

		} else {

			// Add the handler back in; if it's a 400 error from the payment API it can be submitted again
			// Otherwise the form will be removed anyway
			twire.forms.addValidationHandler($form);

			twireStripe.processPayment('/twire/api/process-booking', {});

		}

	}

};